import { InsuranceType } from '@/common/queries/selections/insurance/insurance.type';
import { fetchApi } from '@/config/axiosSetting';

export const getInsuranceFunction = ({
  name,
}: {
  name: string | null;
}): Promise<InsuranceType[]> => {
  return fetchApi.get('/selection_item/insurance/wop_list/', {
    params: {
      name,
    },
  });
};
